<template>
  <CContainer fluid>
    <h3>Pipeline de Ventas</h3>
      <CRow>
        <CCol col="4" sm="4">
          <CCard class="mt-4">
            <CCardBody>
              <CRow>
                <CCol col="sm-12" sm="12">
                  <CInput label="Buscar: " :value.sync="searchWord" @input="(value) => {
                    getData(1, searchWord)
                  }">
                    <template #prepend-content>
                      <a href="#" @click="getData(1)">
                        <i class="bi bi-arrow-clockwise"></i>
                      </a>
                    </template>
                    <template #append-content>
                      <a href="#" @click="getData(1, searchWord)">
                        <i class="bi bi-search"></i>
                      </a>
                    </template>
                  </CInput>
                </CCol>
              </CRow>
              <CDataTable 
                hover 
                :items="items" 
                :fields="fields" 
                :items-per-page="itemsPerPage">
                <template #consecutivo="{ item }">
                  <td>
                    <div>
                      <h4>{{ item.consecutivo }}</h4>
                    </div>
                    <div>
                      <span>{{ item.clase_Seguimiento }}</span>
                    </div>
                  </td>
                </template>
                <template #seguimiento="{ item }">
                  <td>
                    <div>
                      <strong>{{ item.empleado }}</strong>
                    </div>
                    <div>
                      <small>{{ item.comentarios }}</small>
                    </div>
                  </td>
                </template>
                <template #fecha="{ item }">
                  <td>
                    <div>
                      <i class="bi bi-calendar"></i>
                      <span> {{ moment(item.fecha_Hora).format('DD/MM/YYYY') }}</span>
                    </div>
                    <div>
                      <i class="bi bi-clock"></i>
                      <span> {{ moment(item.fecha_Hora).format('HH:mm') }}</span>
                    </div>
                  </td>
                </template>
              </CDataTable>
              <CPagination size="sm" class="d-flex justify-content-center" :activePage.sync="page" :pages="pageCount"
                @update:activePage="(value, a) => getData(value, searchWord)" />
            </CCardBody>
          </CCard>      
          
          <LoadingCover v-show="loading" />
        </CCol>
        <CCol col="4" sm="4">
          <CCard class="mt-4">
            <CCardBody>
              <CRow>
                <CCol col="sm-12" sm="12">
                  <CInput label="Buscar: " :value.sync="searchWord" @input="(value) => {
                    getData(1, searchWord)
                  }">
                    <template #prepend-content>
                      <a href="#" @click="getData(1)">
                        <i class="bi bi-arrow-clockwise"></i>
                      </a>
                    </template>
                    <template #append-content>
                      <a href="#" @click="getData(1, searchWord)">
                        <i class="bi bi-search"></i>
                      </a>
                    </template>
                  </CInput>
                </CCol>
              </CRow>
              <CDataTable hover :items="items" :fields="fields" :items-per-page="itemsPerPage">
                <template #consecutivo="{ item }">
                  <td>
                    <div>
                      <h4>{{ item.consecutivo }}</h4>
                    </div>
                    <div>
                      <span>{{ item.clase_Seguimiento }}</span>
                    </div>
                  </td>
                </template>
                <template #seguimiento="{ item }">
                  <td>
                    <div>
                      <strong>{{ item.empleado }}</strong>
                    </div>
                    <div>
                      <small>{{ item.comentarios }}</small>
                    </div>
                  </td>
                </template>
                <template #fecha="{ item }">
                  <td>
                    <div>
                      <i class="bi bi-calendar"></i>
                      <span> {{ moment(item.fecha_Hora).format('DD/MM/YYYY') }}</span>
                    </div>
                    <div>
                      <i class="bi bi-clock"></i>
                      <span> {{ moment(item.fecha_Hora).format('HH:mm') }}</span>
                    </div>
                  </td>
                </template>
              </CDataTable>
              <CPagination size="sm" class="d-flex justify-content-center" :activePage.sync="page" :pages="pageCount"
                @update:activePage="(value, a) => getData(value, searchWord)" />
            </CCardBody>
          </CCard>      
          
          <LoadingCover v-show="loading" />
        </CCol>
        <CCol col="4" sm="4">
          <CCard class="mt-4">
            <CCardBody>
              <CRow>
                <CCol col="sm-12" sm="12">
                  <CInput label="Buscar: " :value.sync="searchWord" @input="(value) => {
                    getData(1, searchWord)
                  }">
                    <template #prepend-content>
                      <a href="#" @click="getData(1)">
                        <i class="bi bi-arrow-clockwise"></i>
                      </a>
                    </template>
                    <template #append-content>
                      <a href="#" @click="getData(1, searchWord)">
                        <i class="bi bi-search"></i>
                      </a>
                    </template>
                  </CInput>
                </CCol>
              </CRow>
              <CDataTable hover :items="items" :fields="fields" :items-per-page="itemsPerPage">
                <template #consecutivo="{ item }">
                  <td>
                    <div>
                      <h4>{{ item.consecutivo }}</h4>
                    </div>
                    <div>
                      <span>{{ item.clase_Seguimiento }}</span>
                    </div>
                  </td>
                </template>
                <template #seguimiento="{ item }">
                  <td>
                    <div>
                      <strong>{{ item.empleado }}</strong>
                    </div>
                    <div>
                      <small>{{ item.comentarios }}</small>
                    </div>
                  </td>
                </template>
                <template #fecha="{ item }">
                  <td>
                    <div>
                      <i class="bi bi-calendar"></i>
                      <span> {{ moment(item.fecha_Hora).format('DD/MM/YYYY') }}</span>
                    </div>
                    <div>
                      <i class="bi bi-clock"></i>
                      <span> {{ moment(item.fecha_Hora).format('HH:mm') }}</span>
                    </div>
                  </td>
                </template>
              </CDataTable>
              <CPagination size="sm" class="d-flex justify-content-center" :activePage.sync="page" :pages="pageCount"
                @update:activePage="(value, a) => getData(value, searchWord)" />
            </CCardBody>
          </CCard>      
          
          <LoadingCover v-show="loading" />
        </CCol>
      </CRow>
    </CContainer>
</template>
<script>
  import moment from "moment";
  import LoadingCover from "@/components/containers/LoadingCover.vue";

  import {dataGridNotificacionesUsuario} from "@/api";
  import { 
    errorMessage,
    formatter
  } from "@/general";

  // import RightSideBar from '../containers/RightSideBar.vue'
  // import VerticalDynamicForm from '../../containers/VerticalDynamicForm.vue'
  // import constants from '../../constants'

  const fields = [
    {
      key: 'consecutivo',
      label: 'Consecutivo',
      _style: 'text-aling:center'
    },
    { 
      key: 'seguimiento', 
      label: 'Seguimiento', 
      _style:'text-align:center;'
    },
    { 
      key: 'fecha', 
      label: 'Fecha', 
      _style:'text-align:center;'
    }
  ]

  export default {
    data() {
      return {
        items: [],
        fields,
        formatter,
        loading: false,
        // confirmationModal: false,
        // opportunity2delete: '',
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: ''
      }
    },
    components: {
      LoadingCover
      // RightSideBar,
      // VerticalDynamicForm
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true
        this.searchWord = search

        try {
          const { count, results } = await dataGridNotificacionesUsuario(
            this,
            this.$store.state.user.data.id_Empleado,
            page,
            search
          )
          
          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }

          this.items = results
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: errorMessage(error),
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      // toggleDocument(e, item){
      //   e.stopPropagation()
      //   this.$set(item, '_toggled', !item._toggled)
      //   this.$nextTick(() => { })
      // },
      // goTo(item, to) {

      //   this.$router.push(`/empresa/mercadeo/oportunidades/${to}`)
      // },
    },
    mounted() {
      this.getData(this.page, this.searchWord)
    },
    computed: {
      // isValidForm() {
      //   return this.trackingdocs_fields.every(field => {
      //     if(field.required) {
      //       if(field.key === 'dateTracking' || field.key === 'timeTracking') {
      //         return this.now.isSameOrBefore(`${this.trackingdocs_fields[1].value}T${this.trackingdocs_fields[2].value}`, 'minutes')
      //       }
      //       if(typeof field.value === 'string') {
      //         return field.value.length > 0
      //       }

      //       return field.value > 0
      //     }

      //     return true
      //   })
      // }
    }
  }
</script>